import { FormFieldTypeEnum } from '../../../enums/FormFieldTypeEnum';

export const convertResponseToSections = (data: any, t: any) => {
  return {
    sectionProfilePictureBelow: [
      {
        key: 'name',
        label: t('name'),
        value:
          data.firstName?.trim() && data.lastName?.trim()
            ? `${data.firstName.trim()} ${data.lastName.trim()}`
            : data.fullName?.trim(),
        editable: false,
        required: true,
        type: FormFieldTypeEnum.INPUT,
      },
      {
        key: 'role',
        label: t('role'),
        value: data.role,
        editable: false,
        required: false,
        type: FormFieldTypeEnum.INPUT,
      },
    ],
    sectionAdminUp: [
      {
        key: 'firstName',
        label: t('firstName'),
        value: data.firstName?.trim(),
        editable: true,
        required: true,
        type: FormFieldTypeEnum.INPUT,
      },
      {
        key: 'lastName',
        label: t('lastName'),
        value: data.lastName?.trim(),
        editable: true,
        required: true,
        type: FormFieldTypeEnum.INPUT,
      },
      {
        key: 'role',
        label: t('role'),
        value: data.role?.trim(),
        editable: false,
        required: true,
        type: FormFieldTypeEnum.INPUT,
      },
      {
        key: 'email',
        label: t('email'),
        value: data.email?.trim(),
        editable: false,
        required: true,
        type: FormFieldTypeEnum.EMAIL,
      },
      {
        key: 'position',
        label: t('position'),
        value: data.position,
        editable: true,
        required: false,
        type: FormFieldTypeEnum.INPUT,
      },
      {
        key: 'department',
        label: t('department'),
        value: data.department,
        editable: true,
        required: false,
        type: FormFieldTypeEnum.INPUT,
      },
      {
        key: 'organization',
        label: t('organization'),
        value: data.organization,
        editable: true,
        required: false,
        type: FormFieldTypeEnum.INPUT,
      },
      {
        key: 'last_login_time',
        label: t('last_login_time'),
        value: new Date(parseInt(data.lastLogin)).toLocaleString('en-US'),
        editable: false,
        required: true,
        type: FormFieldTypeEnum.DATE_TIME,
      },
    ],
  };
};
